export const LinkTypes = {
  PAGE: "page",
  LINK: "direct",
  EMAIL: "email",
};

export const SOURCES_OPTIONS = (t) => {
  return [
    {
      value: LinkTypes.PAGE,
      label: t("confluence-page"),
    },
    {
      value: LinkTypes.LINK,
      label: t("direct-link"),
    },
    {
      value: LinkTypes.EMAIL,
      label: t("email-address"),
    },
  ];
};
